<template>
  <div>
    <Card>
      <ui-input-time
        v-model="from"
        default="00:00"
      ></ui-input-time>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';

const from = ref('');
</script>
